export const SETTINGS_UPDATE_LEARNING_AREAS = 'SETTINGS_UPDATE_LEARNING_AREAS'
export const SETTINGS_SELECTED_DATA_BY_AREA = 'SETTINGS_SELECTED_DATA_BY_AREA'

export const updateLearningAreas = (learningAreas = []) => ({
	type: SETTINGS_UPDATE_LEARNING_AREAS,
	payload: { learningAreas }
})

export const selectedDataByArea = (payload) => ({
	type: SETTINGS_SELECTED_DATA_BY_AREA,
	payload
})